// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip[data-v-0c00bdfc]{top:0;right:-210px}.closer[data-v-0c00bdfc]{background-color:rgba(0,0,0,.3)}.fade-enter-active[data-v-0c00bdfc],.fade-leave-active[data-v-0c00bdfc]{-webkit-transition:opacity .5s;transition:opacity .5s}.fade-enter[data-v-0c00bdfc],.fade-leave-to[data-v-0c00bdfc]{opacity:0}", ""]);
